import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'or', pure: true })
export class OrPipe implements PipeTransform {
  transform(value?: string, alternative?: string): string {
    return !!value && value.length > 1 ? value : !!alternative && alternative.length > 1 ? alternative : '';
  }
}
